export const GET_FREQUENCY_USAGE = 'GET_FREQUENCY_USAGE';
